/** Focus the first field that needs correction after React has rendered its error. */
export function focusFirstField(ids: string[]): void {
  if (typeof window === "undefined") return;

  window.requestAnimationFrame(() => {
    for (const id of ids) {
      const field = document.getElementById(id);
      if (field instanceof HTMLElement) {
        field.focus({ preventScroll: true });
        field.scrollIntoView({ block: "center", inline: "nearest" });
        return;
      }
    }
  });
}
